/**
 * Device detection utilities
 * @module lib/deviceDetection
 */

function detectDevice() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return 'desktop';
  }

  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) ? navigator.userAgent : '';
  const isIpad =
    /iPad/i.test(ua)
    || (/Macintosh/i.test(ua) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1);
  if (isIpad) {
    return 'tablet';
  }

  const width = window.innerWidth || document.documentElement.clientWidth || 1024;
  if (width <= 768) return 'mobile';
  if (width <= 1024) return 'tablet';
  return 'desktop';
}

module.exports = { detectDevice };
